import Chip from "components/chip";

import { Filters } from "types/filters";

interface CurrentFiltersProps {
  resourcesName: string;
  loading?: boolean;
  onClick?: () => void;
  filters: Filters;
}

export default function CurrentFilters(
  props: CurrentFiltersProps
): JSX.Element {
  const { resourcesName } = props;
  const { onClick } = props;
  const { loading } = props;
  const filters = props.filters || {};

  const chips = [
    chipElem("institution"),
    chipElem("year"),
    chipElem("subject"),
    chipElem("topic"),
    chipElem("testDay", `${filters.testDay}º dia`)
  ].filter((chip) => !!chip);

  function chipElem(attribute, label = null) {
    const value = filters[attribute]?.name || filters[attribute];
    if (!value) return;

    return (
      <Chip
        key={value}
        text={label || value}
        loading={loading}
        className={`${attribute} mr-2`}
        onClick={onClick}
      ></Chip>
    );
  }

  return (
    <div id="current-filters" className="flex items-start justify-start">
      {chips.length > 0 ? (
        chips
      ) : (
        <Chip
          text={`${resourcesName} aleatórias`}
          className="mr-2"
          key="random-questions"
          loading={loading}
          onClick={onClick}
        />
      )}
    </div>
  );
}
